import Actions from './experience-insights-actions';
import Api from './experience-insights-api';
import Model from './experience-insights-model';
import reducer from './experience-insights-reducer';
import sagas from './experience-insights-sagas';
import Selectors from './experience-insights-selectors';

export default {
  Actions,
  Api,
  Model,
  namespace: 'experienceInsights',
  reducer,
  sagas:     [sagas],
  Selectors,
};
